import type {FilesItem} from 'store/slices/files/types';
import {AiChatFilterSection} from './AiChatFilterSection';

interface Props {
  fileList: FilesItem[];
  onRemove: (file: FilesItem) => void;
}

export function AiChatFilterAttachSection({fileList, onRemove}: Props) {
  const hasAttachFiles = fileList.length > 0;

  return (
    hasAttachFiles && (
      <AiChatFilterSection
        files={fileList}
        onRemove={onRemove}
        type="attachment"
      />
    )
  );
}
